export default async function uploadFile({fields, key, url}, file) {
  var formData = new FormData()
  const data = {
    ...fields,
    key: key,
    file: file
  }

  for (const name in data) {
    formData.append(name, data[name])
  }

  await fetch(url, {
    method: 'POST',
    body: formData
  })
}
